/**
 * @file BinLabelsLayer.tsx
 * @description Слой печати этикеток страницы «Ячейки» (phase19.22 шаг 5):
 *   диалог печати и шторка «История печати ячеек». Страница вставляет его
 *   одной строкой рядом с остальными диалогами.
 */

import { BinLabelPrintDialog } from "./BinLabelPrintDialog";
import type { BinLabels } from "./useBinLabels";
import { LabelPrintLogSheet } from "../labels/LabelPrintLogSheet";

interface Props {
  labels: BinLabels;
  warehouseId: string;
  warehouseName?: string;
}

export function BinLabelsLayer({ labels, warehouseId, warehouseName }: Props) {
  if (!labels.selection) return null;
  return (
    <>
      <BinLabelPrintDialog
        open={labels.printOpen}
        onOpenChange={labels.setPrintOpen}
        warehouseId={warehouseId}
        subtitle={warehouseName}
        selected={labels.selection.selected}
        scope={labels.selection.scope}
        onPrinted={labels.onPrinted}
      />
      <LabelPrintLogSheet
        open={labels.historyOpen}
        onOpenChange={labels.setHistoryOpen}
        labels={labels.jobs}
        title="История печати ячеек"
        showLines={false}
        emptyText="Этикетки ячеек на этом складе ещё не печатались."
      />
    </>
  );
}
